/* Consent-first Microsoft Clarity loader for approved public pages only. */
(function (root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.boot(root.document);
})(typeof window !== 'undefined' ? window : null, function (root) {
  'use strict';

  function consentSignal(analyticsAllowed, marketingAllowed) {
    return {
      ad_Storage: marketingAllowed ? 'granted' : 'denied',
      analytics_Storage: analyticsAllowed ? 'granted' : 'denied'
    };
  }
  function shouldLoad(surface, analyticsAllowed, alreadyLoaded) {
    return surface === 'allowed' && analyticsAllowed === true && alreadyLoaded !== true;
  }
  function boot(doc) {
    if (!doc || !doc.body || root.__bbClarityGateBooted) return;
    root.__bbClarityGateBooted = true;
    var source = doc.currentScript || doc.querySelector('script[data-project-id][src*="bb-clarity-gate"]');
    var projectId = source && source.getAttribute('data-project-id');
    var surface = doc.body.getAttribute('data-bb-clarity') || 'blocked';
    var loaded = false;
    var revoking = false;

    function existingTag() { return !!doc.querySelector('script[src*="clarity.ms/tag/"]'); }
    function privacy() { return root.Shopify && root.Shopify.customerPrivacy; }
    function analyticsAllowed() {
      var customerPrivacy = privacy();
      try { return !!(customerPrivacy && customerPrivacy.analyticsProcessingAllowed && customerPrivacy.analyticsProcessingAllowed()); }
      catch (error) { return false; }
    }
    function marketingAllowed() {
      var customerPrivacy = privacy();
      try { return !!(customerPrivacy && customerPrivacy.marketingAllowed && customerPrivacy.marketingAllowed()); }
      catch (error) { return false; }
    }
    function queue() {
      root.clarity = root.clarity || function () { (root.clarity.q = root.clarity.q || []).push(arguments); };
      return root.clarity;
    }
    function load() {
      var duplicate = existingTag();
      if (loaded) {
        queue()('consentv2', consentSignal(true, marketingAllowed()));
        return;
      }
      if (!shouldLoad(surface, analyticsAllowed(), loaded || duplicate) || !projectId) {
        if (duplicate && !loaded) doc.body.setAttribute('data-bb-clarity-conflict', 'duplicate-tag');
        return;
      }
      loaded = true;
      var clarity = queue();
      clarity('consentv2', consentSignal(true, marketingAllowed()));
      var script = doc.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(projectId) + '?ref=bb-consent-gate';
      script.setAttribute('data-bb-clarity-tag', projectId);
      (doc.head || doc.documentElement).appendChild(script);
    }
    function revokeAndReload() {
      if (!loaded || revoking) return;
      revoking = true;
      try {
        queue()('consentv2', consentSignal(false, marketingAllowed()));
        queue()('consent', false);
      } catch (error) {}
      root.setTimeout(function () { root.location.reload(); }, 0);
    }
    function sync() {
      if (surface !== 'allowed') return;
      if (analyticsAllowed()) load();
      else revokeAndReload();
    }

    doc.addEventListener('visitorConsentCollected', sync);
    doc.addEventListener('bb:consent-changed', sync);
    if (root.Shopify && root.Shopify.loadFeatures) {
      root.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) sync();
      });
    }
  }

  return { consentSignal: consentSignal, shouldLoad: shouldLoad, boot: boot };
});
